export const formGrid = (group, tournamentState) => {
	const formedGroupNodes = formGroupNodes(
		group,
		tournamentState?.players,
		tournamentState?.type,
		tournamentState?.doubles
	)
	const resultsColumn = formResultsColumn(formedGroupNodes)
	const arraysOfPairedNodes = uniteNodesInPairs(formedGroupNodes)
	const unitedNodesAndMatches = includeMatchesInNodesPairs(arraysOfPairedNodes, group?.matches)
	const arrayOfGroupedNodes = uniteNodesPairsInArrays(unitedNodesAndMatches)
	const namedRounds = addNamesOfRounds(arrayOfGroupedNodes)
	const pairedNodesWithHighLight = nodesPairsWithHighlight(namedRounds, namedRounds[0]?.matches?.length)

	return { activeColumns: pairedNodesWithHighLight, resultsColumn }
}

const formResultsColumn = (nodes) => {
	const outgoingNodes = nodes?.filter(n => n?.type === 'outgoing')
	const incomingNodes = nodes?.filter(n => n?.type === 'incoming')

	const results = incomingNodes?.map((i, index) => {
		if (outgoingNodes[index]) {
			return outgoingNodes[index]
		} else {
			return { name: '---' }
		}
	})

	return results
}

const formGroupNodes = (group, players, type, doubles) => {
	const formedGroupNodes = group?.nodes?.map((node) => {
		let formedNode = {}

		if (type === 'singles') {
			const participant = players?.find((p) => p.uid === node?.player_uid)
			let name = participant?.formedName
			let available = true

			if (!participant?.player1?.formedName && node?.disabled) {
				name = '---'
				available = false
			}  
			else if (!participant?.formedName && !node?.disabled) {
				name = node?.name
				available = false
			}

			formedNode = {
				nodeUid: node?.uid,
				playerUid: participant?.uid ? participant?.uid : null,
				name: name,
				type: node?.type,
				roundNumber: node?.round_number === null && node?.type === 'incoming' ? 1 : node?.round_number,
				available
			}

		} else if (type === 'doubles') {
			const participant = doubles?.find((p) => p.uid === node?.double_uid)
			let name = null
			let nameOne = participant?.player1?.formedName
			let nameTwo = participant?.player2?.formedName
			let available = true

			if (!participant?.player1?.formedName && node?.disabled) {
				nameOne = '---'
				available = false
			} 
      
			if (!participant?.player2?.formedName && node?.disabled) {
				nameTwo = '---'
				available = false
			}

			if (!participant?.player1?.formedName && !participant?.player2?.formedName && !node?.disabled) {
				name = node?.name
				available = false
			}

			formedNode = {
				nodeUid: node?.uid,
				firstPlayerUid: participant?.player1?.uid ? participant?.player1?.uid : null,
				secondPlayerUid: participant?.player2?.uid ? participant?.player2?.uid : null,
				firstPlayerName: nameOne,
				secondPlayerName: nameTwo,
				type: node?.type,
				roundNumber: node?.round_number === null && node?.type === 'incoming' ? 1 : node?.round_number,
				name,
				available
			}
		}

		return formedNode
	})

	return formedGroupNodes
}

const uniteNodesInPairs = (nodes) => {
	const filtredNodes = nodes?.filter(n => n?.type !== 'outgoing')

	return filtredNodes?.reduce((pairs, obj, index) => {

		if (filtredNodes?.length > 1){
			if (index % 2 === 0) {
				pairs.push({
					match: false,
					nodeOne: obj,
					nodeTwo: nodes[index + 1],
					roundNumber: obj?.roundNumber
				})
			}
		} else {
			pairs?.push({
				match: false,
				nodeOne: obj,
				roundNumber: obj?.roundNumber
			})
		}

		return pairs
	}, [])
}

const includeMatchesInNodesPairs = (pairs, matches) => {
	for (let i = 0; i < pairs.length; i++) {
		const item = pairs[i]
		let matched = false

		for (const m of matches) {
			if (item?.nodeOne?.nodeUid === m?.side1_uid && item?.nodeTwo?.nodeUid === m?.side2_uid) {
				pairs[i] = {
					...item,
					match: true,
					matchNumber: m?.order_number,
					gridColumnPosition: m?.round_grid_position_number,
					roundNumber: m?.round_number,
					matchUid: m?.uid,
					sets: m?.sets,
					pairNumber: i + 1
				}

				matched = true

				break
			}
		}

		if (!matched) {
			pairs[i] = {
				...item,
				pairNumber: i + 1
			}
		}
	}

	return pairs
}

const uniteNodesPairsInArrays = (nodes) => {
	const result = []
	let tempArray = [nodes[0]]

	for (let i = 0; i < nodes.length; i++) {
		if (nodes[i]?.roundNumber === nodes[i + 1]?.roundNumber) {
			tempArray.push(nodes[i + 1])
		} 
		else {
			result.push(tempArray)
			tempArray = [nodes[i + 1]]
		}
	}

	return result
}

const addNamesOfRounds = (arrays) => {
	let firstRoundName = arrays[0]?.length

	const updatedArrays = arrays?.map((a, index) => {
		const newObject = {
			roundName: firstRoundName !== 1 ? `1/${firstRoundName}` : 'Final',
			matches: a
		}
		firstRoundName = firstRoundName / 2

		return newObject
	})

	return updatedArrays
}

const nodesPairsWithHighlight = (arrays, number) => {
	const arrayWithDevidedArrays = formArrayWithDevidedArrays(arrays, number)
	const nodesPairsWithHighlight = addHighLightToNodesPairs(arrayWithDevidedArrays)

	return nodesPairsWithHighlight
}


const formArrayWithDevidedArrays = (arrays, number) => {
	let start = number / 2
	const a = arrays?.map((b, index) => {
		if (index === 0) {
			return b
		} 
		else {
			const c = divideArray(b, start)
			start = start / 2
      
			return { ...b, matches: c }
		}
	})

	return a
}

const divideArray = (array, n) => {
	const result = []

	for (let i = 0; i < array?.matches?.length; i += n) {
		const chunk = array?.matches?.slice(i, i + n)
		result.push(chunk)
	}

	return result
}

const addHighLightToNodesPairs = (array) => {
	const nodesPairsWithHighlight = array?.map((a, index) => {
		if (index === 0) {
			return a
		} 
		else {
			const updatedArrays = a?.matches?.map((item, itemIndex) => {
				if (itemIndex % 2 !== 0) {
					const updatedPairs = item?.map((el, elIndex) => {
						let updatedPair = { ...el, highlight: true }

						if (elIndex === 0 && item?.length === 1) {
							updatedPair = { ...updatedPair, borderTop: true, borderBottom: true }
						} 
						else if (elIndex === 0 && item?.length > 1) {
							updatedPair = { ...updatedPair, borderTop: true }
						} 
						else if (elIndex === item?.length - 1) {
							updatedPair = { ...updatedPair, borderBottom: true }
						}

						return updatedPair
					})

					return updatedPairs
				} 
				else {
					return item
				}
			})

			return { ...a, matches: updatedArrays.flat() }
		}
	})

	return nodesPairsWithHighlight
}
